module.exports = __webpack_public_path__ + "static/media/googleColor.22afc494.svg";